import { requests, mainApiRoot } from './index'

export const Favourites = {
  getAll: () => requests.get(mainApiRoot, '/favourites/'),
  get: id => requests.get(mainApiRoot, `/favourites/${id}`),
  create: payload => requests.post(mainApiRoot, '/favourites/', { list: payload }),
  update: (id, payload) => requests.put(mainApiRoot, `/favourites/${id}`, { list: payload }),
  del: id => requests.del(mainApiRoot, `/favourites/${id}`),
  deleteItems: (id, ids) =>
    requests.put(mainApiRoot, `/favourites/${id}`, {
      favourites: {
        remove_item_uuids: ids
      }
    }),
  export: id => requests.getFile(mainApiRoot, `/favourites/${id}/csv`)
}